import React, { Component } from "react";
import {
  MDBDataTable,
  MDBTableHead,
  MDBTableBody,
  MDBTable,
  MDBBtn,
} from "mdbreact";
import {
  AvInput,
  Card,
  CardBody,
  Col,
  Form,
  Row,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Button,
  Modal,
  Container,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import {
  addFoodDeliveryBoy,
  getFoodDeliveryBoyList,
  getFoodDeliveryBoyById,
  updateFoodDeliveryBoy,
  removeFoodDeliveryBoy,
} from "../../Endpoint/Admin/index";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

import { AvForm, AvField } from "availity-reactstrap-validation";
import { first } from "lodash";

class DeliveryBoy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoaded: false,
      updatemodal: false,
      modal: false,
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      country: "",
      postalCode: "",
      dBoyId: "",
      success: {},
      breadcrumbItems: [
        { title: "", link: "#" },
        { title: "", link: "#" },
      ],
      customchk: true,
      toggleSwitch: true,
      tableData: {
        columns: [
          {
            label: " FirstName",
            field: "firstName",
            sort: "asc",
            width: 60,
          },
          {
            label: " Mobile ",
            field: "mobile",
            sort: "asc",
            width: 60,
          },
          {
            label: " Email ",
            field: "email",
            sort: "asc",
            width: 60,
          },

          {
            label: "Update",
            field: "update",
            sort: "asc",
            width: 100,
          },

          {
            label: "Remove",
            field: "remove",
            sort: "asc",
            width: 100,
          },
        ],
        rows: [],
      },
    };
    this.reader = new FileReader();
    this.handleChange = this.handleChange.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);

    this.updatetoggle = this.updatetoggle.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      country: "",
      postalCode: "",
      dBoyId: "",
    });
  }
  updatetoggle() {
    this.setState({
      updatemodal: !this.state.updatemodal,
    });
  }

  handleCloseModal() {
    this.setState({
      updatemodal: false,
      modal: false,
    });
  }

  handleChange = (e) => {
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {}
    );
  };

  handleSubmit(e) {
    e.preventDefault();
    const userObject = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      mobile: this.state.mobile,
      country: this.state.country,
      postalCode: this.state.postalCode,
      dBoyId: this.state.dBoyId,
    };
    if (this.state.dBoyId == "" || this.state.dBoyId == null) {
      addFoodDeliveryBoy(userObject)
        .then((response) => {
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                firstName: "",
                lastName: "",
                email: "",
                mobile: "",
                country: "",
                postalCode: "",
                dBoyId: "",
              },
            });
            this.getALlluser();
            this.handleCloseModal();
            toast.success(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      updateFoodDeliveryBoy(userObject)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "success",

                dBoyId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();
            toast.success(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }
  getALlluser() {
    getFoodDeliveryBoyList().then((result) => {
      this.setState({
        isLoaded: true,
        items: result.data,
        tableData: {
          ...this.state.tableData,
          rows: result.data,
          list: result.data.map((x) => {
            x.update = (
              <button
                className="btn btn-primary"
                onClick={() => this.editDeliveryBoy(x._id.toString(), x)}
              >
                Update
              </button>
            );
            x.remove = (
              <button
                className="btn btn-danger"
                onClick={() => this.removeDeliveryBoy(x._id.toString())}
              >
                Remove
              </button>
            );

            return x;
          }),
        },
      });
    });
  }
  removeDeliveryBoy(id) {
    removeFoodDeliveryBoy(id)
      .then((results) => {
        toast.success(results.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        this.getALlluser();
      })
      .catch((error) => {
        toast.error("error");
      });
  }
  componentDidMount() {
    this.getALlluser();
  }

  editDeliveryBoy(id) {
    getFoodDeliveryBoyById(id)
      .then((results) => {
        this.setState({
          dBoyId: results.data._id,
          firstName: results.data.firstName,
          lastName: results.data.lastName,
          email: results.data.email,
          mobile: results.data.mobile,
          country: results.data.country,
          postalCode: results.data.postalCode,
          country: results.data.country,
        });
      })
      .catch((error) => {
        toast.error("error");
      });
    this.toggle();
  }

  render() {
    const { handleResponse, invalidImage, items, previewImage } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title=""
              breadcrumbItems={this.state.breadcrumbItems}
            />

            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <Button color="primary" onClick={this.toggle}>
                      Add Delivery Boy
                    </Button>
                    <Modal
                      isOpen={this.state.modal}
                      toggle={this.toggle}
                      className={this.props.className}
                    >
                      <ModalHeader toggle={this.toggle}>
                        Delivery Boy Details
                      </ModalHeader>
                      <ModalBody>
                        <AvForm onValidSubmit={this.handleSubmit}>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="name">First Name</Label>
                                <AvField
                                  type="text"
                                  value={this.state.firstName}
                                  onChange={this.handleChange}
                                  id="firstName"
                                  name="firstName"
                                  required
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="ID">Last Name</Label>
                                <AvField
                                  type="text"
                                  value={this.state.lastName}
                                  onChange={this.handleChange}
                                  id="lastName"
                                  name="lastName"
                                  required
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="ID">Email</Label>
                                <AvField
                                  type="text"
                                  value={this.state.email}
                                  onChange={this.handleChange}
                                  id="email"
                                  name="email"
                                  required
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="ID">Mobile</Label>
                                <AvField
                                  type="number"
                                  min={0}
                                  value={this.state.mobile}
                                  onChange={this.handleChange}
                                  id="mobile"
                                  name="mobile"
                                  required
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="ID">Country</Label>
                                <AvField
                                  type="text"
                                  value={this.state.country}
                                  onChange={this.handleChange}
                                  id="country"
                                  name="country"
                                  required
                                />
                              </FormGroup>
                            </Col>
                            {/* <Col md={6}>
            <FormGroup>
            <Label for="ID">PostalCode</Label>
              <AvField   type="text"  value={this.state.postalCode} onChange={this.handleChange}  id="postalCode"  name="postalCode" required />


            </FormGroup>
          </Col> */}
                          </Row>

                          <div className="text-center">
                            <Button color="primary" size="sm">
                              Submit
                            </Button>{" "}
                          </div>
                        </AvForm>
                      </ModalBody>
                    </Modal>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Breadcrumbs
              title="Data Tables"
              breadcrumbItems={this.state.breadcrumbItems}
            />

            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <h4 className="card-title">Delivery Boy Datatable </h4>
                    <p className="card-title-desc"></p>

                    <MDBDataTable
                      responsive
                      bordered
                      data={this.state.tableData}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <ToastContainer />
      </React.Fragment>
    );
  }
}

export default DeliveryBoy;
